import React from 'react';

import { Icon } from '@vk-hr-tek/ui/Icon';

import { ModulesConfig, modules } from '../modules';
import { Resources } from '../ability';

import { NavigationItem, MetaTitle } from './router.types';

interface ModuleToNavigationParams {
  basename: string;
  resource: Resources;
  parentResource?: Resources;
  link?: string;
}

interface ModuleNavigationResult {
  aqaClass: string;
  href: string;
  resource: Resources;
  parentResource?: Resources;
  basename: string;
}

const moduleToNavigation = (
  { basename, parentResource, resource, link }: ModuleToNavigationParams,
  parent?: string,
): ModuleNavigationResult => {
  const href =
    link ||
    `${parent && parent !== basename ? `/${parent}` : ''}${
      basename && '/'
    }${basename}`;

  return {
    aqaClass: `aqa${
      parent && parent !== basename ? `_${parent.replaceAll('-', '_')}` : ''
    }${basename && '_'}${basename.replaceAll('-', '_')}`,
    href,
    resource,
    basename,
    parentResource,
  };
};

const createNavigation = (config: ModulesConfig): NavigationItem[] => {
  return Object.keys(config)
    .filter((key: string): key is keyof ModulesConfig => !!key)
    .filter((key) => config[key].withSide)
    .map((key) => {
      const module = config[key];
      const ModuleIcon = module.icon;

      return {
        ...moduleToNavigation(module),
        icon: ModuleIcon ? (
          <ModuleIcon />
        ) : (
          <Icon name="home_outline" size="20" color="text.light.primary" />
        ),
        ...(key.includes('dropdown_')
          ? {
              submenu: Object.values(config)
                .filter(
                  (childModule) =>
                    childModule.basename.includes(module.basename) &&
                    childModule !== module,
                )
                .map((child) => moduleToNavigation(child, module.basename)),
            }
          : {}),
      };
    });
};

export const navigationItems = createNavigation(modules);

export const metaTitles: MetaTitle[] = [
  ...navigationItems.map(
    ({ parentResource, resource, basename, href, submenu }) => ({
      parentResource,
      resource,
      basename,
      href,
      submenu,
    }),
  ),
  {
    completeTitle: {
      company: 'Вход в личный кабинет',
      employee: 'Вход в личный кабинет',
    },
    href: '/auth',
  },
  {
    completeTitle: { company: 'Личный кабинет', employee: 'Личный кабинет' },
    href: '/',
  },
  {
    completeTitle: { company: 'Заявки', employee: 'Заявки' },
    href: '/events',
  },
  {
    completeTitle: { company: 'Профиль', employee: 'Профиль' },
    href: '/profile',
  },
  {
    completeTitle: { company: 'Профиль', employee: 'Профиль' },
    href: '/create-certificate',
  },
];
